import request from "@/utils/request";

export function getList(params) {
  return request({
    url: "/HostelDiagram/GetHostelGroup",
    method: "get",
    params
  });
}
export function changeBed(data) {
  return request({
    url: "/HostelDiagram/ExchangeBedState",
    method: "post",
    data
  });
}

export function changeRoom(data) {
  return request({
    url: "/HostelDiagram/ExchangeRoomType",
    method: "post",
    data
  });
}
